<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>查询条件</span>
          </div>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-input
                v-model="recommendGoodsManageInfo.conditions.prodName"
                placeholder="请输入商品名称"
                clearable
              />
            </el-col>
            <el-col :span="6">
              <el-input
                v-model="recommendGoodsManageInfo.conditions.productId"
                placeholder="请输入商品ID"
                clearable
              />
            </el-col>
            <el-col :span="6">
              <el-input
                v-model="recommendGoodsManageInfo.conditions.barCode"
                placeholder="请输入产品条形码"
                clearable
              />
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="_queryProductMethod">
                <i class="el-icon-search"></i> 查询
              </el-button>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

    <el-row style="margin-top: 20px;">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>推荐商品</span>
            <el-button
              type="primary"
              size="small"
              style="float: right;"
              @click="openChooseLabelProductModel"
            >
              <i class="el-icon-search"></i> 选择商品
            </el-button>
          </div>
          <el-table
            :data="recommendGoodsManageInfo.products"
            border
            style="width: 100%"
          >
            <el-table-column prop="productId" label="商品ID" align="center" />
            <el-table-column label="商品图片" align="center">
              <template slot-scope="scope">
                <el-image
                  style="width: 60px; height: 60px; border-radius: 5px;"
                  :src="scope.row.coverPhoto"
                  fit="cover"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column prop="prodName" label="商品名称" align="center" />
            <el-table-column prop="createTime" label="创建时间" align="center" />
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="openDeleteLabelProductModel(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            style="margin-top: 20px; text-align: right;"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="recommendGoodsManageInfo.total"
          ></el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <choose-label-product ref="chooseLabelProduct" @chooseLabelProduct="handleChooseLabelProduct" />
    <delete-label-product ref="deleteLabelProduct" @listProduct="handleListProduct" />
  </div>
</template>

<script>
import { queryProductLabel, saveProductLabel } from '@/api/goods/recommendGoodsApi'
import ChooseLabelProduct from '@/components/goods/chooseLabelProduct'
import DeleteLabelProduct from '@/components/goods/deleteLabelProduct'

export default {
  name: 'RecommendGoodsManage',
  components: {
    ChooseLabelProduct,
    DeleteLabelProduct
  },
  data() {
    return {
      recommendGoodsManageInfo: {
        products: [],
        total: 0,
        records: 1,
        moreCondition: false,
        productId: '',
        conditions: {
          prodName: '',
          productId: '',
          barCode: '',
          labelCd: '8800012001',
          hasProduct: 'Y',
          page: 1,
          row: 10
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listProducts(this.currentPage, this.pageSize)
  },
  methods: {
    async _listProducts(page, rows) {
      this.recommendGoodsManageInfo.conditions.page = page
      this.recommendGoodsManageInfo.conditions.row = rows
      
      try {
        const res = await queryProductLabel(this.recommendGoodsManageInfo.conditions)
        this.recommendGoodsManageInfo.total = res.total
        this.recommendGoodsManageInfo.records = res.records
        this.recommendGoodsManageInfo.products = res.data
        this.currentPage = page
      } catch (error) {
        console.error('获取商品列表失败:', error)
      }
    },

    async _saveProductLabel(product) {
      const params = {
        productId: product.productId,
        storeId: product.storeId,
        labelCd: '8800012001'
      }

      try {
        const res = await saveProductLabel(params)
        if (res.code === 0) {
          this.$message.success(res.msg)
          this._listProducts(this.currentPage, this.pageSize)
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('保存商品标签失败:', error)
        this.$message.error('保存商品标签失败')
      }
    },

    _queryProductMethod() {
      this._listProducts(1, this.pageSize)
    },

    handleCurrentChange(val) {
      this._listProducts(val, this.pageSize)
    },

    openChooseLabelProductModel() {
      this.$refs.chooseLabelProduct.open({ labelCd: '8800012001' })
    },

    openDeleteLabelProductModel(product) {
      this.$refs.deleteLabelProduct.open(product)
    },

    handleChooseLabelProduct(product) {
      this._saveProductLabel(product)
    },

    handleListProduct() {
      this._listProducts(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>